export enum OverFlowCollapseFrom {
  Start = 'start',
  End = 'end'
}
